// 启动模块API接口

import utils from "../../../utils";
import { BaseApi } from "../../../utils/request";
import { LtProxy } from "../../../utils";
import { StartupData } from "../../../modules/startup/types";
// datadogRum 动态加载 — 避免静态 import 阻塞模块初始化

// 启动数据API
export class StartupApi extends BaseApi {
  // 获取启动数据
  async getStartupData(lazy: boolean = true): Promise<StartupData> {
    const searchParams = new URLSearchParams(window.location.search);
    const startTime = Date.now();
    let url = `/api/home/startup?lazy=${lazy}&startTime=${startTime}`;
    const params = searchParams.get("p");
    if (params) {
      url += `&p=${params}`;
    }
    // 开发环境添加dev参数
    if (process.env.NODE_ENV === "development") {
      url += "&dev=true";
    }

    // 如果是应用环境，检查剪贴板数据
    if (
      typeof window !== "undefined" &&
      window.navigator?.userAgent &&
      utils.isApp()
    ) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          const clipboardData = await navigator.clipboard.readText();
          if (clipboardData.includes("W2A-")) {
            url += `&wta=${clipboardData.replace("W2A-", "")}`;
          }
        }
      } catch {
        // 剪贴板访问失败，忽略错误
      }
    }

    // 【P1 优化】优先使用 main.tsx 中的预请求结果，避免重复请求
    // 注意：this.get() 返回 axios response（{data: body, status: 200}），
    //       预请求返回的是原始 JSON body，需要包装成相同结构
    const preload = (window as any).__mainStartupPreload;
    let response: any;
    if (preload) {
      (window as any).__mainStartupPreload = null; // 只使用一次
      const preloadResult = await preload;
      if (preloadResult && preloadResult.status === 0) {
        // 包装成 axios response 格式，与 this.get() 返回值一致
        response = { data: preloadResult, status: 200 };
      } else {
        // 预请求失败，回退到正常请求
        response = await this.get<StartupData>(
          url,
          {},
          {
            cache: true,
            cacheTime: 5 * 60 * 1000,
            alert: false,
          }
        );
      }
    } else {
      response = await this.get<StartupData>(
        url,
        {},
        {
          cache: true,
          cacheTime: 5 * 60 * 1000, // 5分钟缓存
          alert: false,
        }
      );
    }
    if (response.status === 0) {
      // 处理构建配置
      if (response.data?.buildConfig) {
        const needAppend =
          !(window as any)._config || !(window as any)._config.varStyles;
        if (!(window as any)._config) {
          (window as any)._config = response.data.buildConfig;
        }
        if (needAppend && response.data.buildConfig.varStyles) {
          document.body.style.cssText =
            (document.body.style.cssText || "") +
            response.data.buildConfig.varStyles;
        }
      }
      // 设置 Datadog RUM 商户标签（动态加载，不阻塞）
      if (response.data?.brand) {
        import("@datadog/browser-rum").then(({ datadogRum }) => {
          datadogRum.setGlobalContextProperty(
            "merchant",
            response.data.brand.name
          );
          datadogRum.setGlobalContextProperty(
            "merchantId",
            response.data.brand.id
          );
        });
      }
      if (
        utils.hasProperty(response.data, "horizontalCom") &&
        response.data?.horizontalCom
      ) {
        LtProxy.enterFullScreen();
        LtProxy.landScreen();
      }
    }
    return response.data;
  }
}

// 创建API实例
export const startupApi = new StartupApi();
